export function selectedTrailUseKeys(targets = []) {
  return Array.from(targets).filter(t => t.checked).map(t => t.dataset.use)
}

export function trailUseAllowed(properties = {}, selectedUses = []) {
  if (!selectedUses.length) return false

  const uses = readUses(properties.uses)
  if (!uses || !Object.values(uses).some(Boolean)) return true
  return selectedUses.some(key => uses[key])
}

function readUses(value) {
  if (!value) return null
  if (typeof value === "object" && !Array.isArray(value)) return value
  if (typeof value !== "string") return null
  try {
    const parsed = JSON.parse(value)
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : null
  } catch {
    return null
  }
}
